import type { ChangeEvent, FC, InputHTMLAttributes } from "react";

type CheckboxButtonProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange"
> & {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  value: string;
  className?: string;
};

export const CheckboxButton: FC<CheckboxButtonProps> = ({
  checked,
  onChange,
  label,
  value,
  className = "",
  ...props
}) => (
  <label
    className={`flex cursor-pointer select-none items-center space-x-2 hover:font-bold ${className}`}
  >
    <span
      className={`flex h-[1.25rem] w-[1.25rem] items-center justify-center ${checked ? "bg-primary" : "bg-[#E1E9F0]"} transition-colors`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        value={value}
        className="absolute h-[1.25rem] w-[1.25rem] cursor-pointer opacity-0"
        {...props}
      />
      {checked && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 10.5L9 14.5L15 7.5"
            stroke="#fff"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
    <span className="font-ambit text-[0.9375rem] not-italic leading-[1.25rem] text-secondary">
      {label}
    </span>
  </label>
);
